import React, { Component } from 'react';
import { withRouter } from 'react-router-dom'
import { GoogleMap, LoadScript, Marker } from '@react-google-maps/api';

  const containerStyle = {
    width: '100%',
    height: '600px'
  };

  const centers = [
      {lat:32.7990136, lng:-116.9028387}
  ]
   
  class GroupsMap extends Component {

    constructor(props) {
        super(props)
        this.state = {
        }
      }
    
    componentDidMount() {
        console.log('GroupsMap::componentDidMount')
    }

    SaveStateToLocalStorage = () => {
        console.log("GroupsMap::SaveStateToLocalStorage")
        let smallGroupWidgetState = JSON.parse(window.sessionStorage.getItem('smallGroupWidgetState'))
        smallGroupWidgetState.currentView = 2;
        window.sessionStorage.setItem('smallGroupWidgetState', JSON.stringify(smallGroupWidgetState))
      }
    
    MarkerOnClick = (_groupID) => {
        console.log("Groups::MarkerOnClick")
        this.SaveStateToLocalStorage()
        this.props.history.push('/SmallGroupWidget/groupdetail?g=' + _groupID)
    }

    render() {
        if (this.props.groups.length > 0) {            
            return (
                <div className='groupsMapDiv'>  
                    <LoadScript googleMapsApiKey="AIzaSyBm38FE22Uw0WODWKI7_6FoucsXbjriIvQ">
                        <GoogleMap mapContainerStyle={containerStyle} center={centers[0]} zoom={9}>
                        <Marker key={0} label={{text:'Shadow Mountain Church',color:'yellow',fontSize:'14px'}} title={'Shadow Mountain Church'} position={centers[0]} />
                            { this.props.groups.map(group => (
                                <Marker key={group.groupID} label={{text:group.groupName,color:'yellow',fontSize:'14px'}} title={group.groupName} position={{lat:parseFloat(group.latitude), lng:parseFloat(group.longitude)}} onClick={()=>this.MarkerOnClick(group.groupID)} />
                            ))}                    
                        </GoogleMap> 
                    </LoadScript>
                </div> 
            )
        } 
        else {
            return (
                <div className='groupsMapDiv'>     
                    {/* using pns info account */}
                    <LoadScript googleMapsApiKey="AIzaSyBm38FE22Uw0WODWKI7_6FoucsXbjriIvQ">
                        <GoogleMap mapContainerStyle={containerStyle} center={centers[0]} zoom={9}>
                            <Marker key={0} label={{text:'Shadow Mountain Church',color:'yellow',fontSize:'14px'}} title={'Shadow Mountain Church'} position={centers[0]} />
                        </GoogleMap> 
                    </LoadScript>
                </div> 
            )
        }
    }
  }

  export default withRouter(GroupsMap) 